var map = {
	"./btn_back.png": "4e62",
	"./btn_point.png": "b0f7",
	"./btn_user.png": "37a1",
	"./btn_vs.png": "57b6",
	"./icon_renzheng.png": "09a0",
	"./img_baozheng.png": "57da",
	"./img_bianma.png": "7f9a9",
	"./img_chanpin_1.png": "4d08",
	"./img_chanpin_2.png": "ba05",
	"./img_chanpin_3.png": "1625",
	"./img_chanpin_4.png": "d157",
	"./img_chanpin_5.png": "6b9c",
	"./img_chanpin_6.png": "869f",
	"./img_chanpin_7.png": "2772",
	"./img_chanpin_8.png": "37a18",
	"./img_guige.png": "9358",
	"./img_jishuwendang.png": "53ce",
	"./img_miaoshu.png": "fe81",
	"./img_shouce.png": "e9bb",
	"./img_shuju.png": "d780",
	"./img_star.png": "4f9c",
	"./img_xiangguanchanping.png": "9a25"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c4de";